export const LINKEDIN = "https://www.linkedin.com/in/rishikesh-sharma-31b483163/";
export const EMAIL = "rishikesh.sharma8587@gmail.com";
export const PHONE = "+91 9920339322";
export const HEADSHOT_FALLBACK = "https://customer-assets-lqy194kg.emergentagent.net/job_c872d616-ded6-4830-9323-a22369ce1426/artifacts/kf3pwso3_WhatsApp%20Image%202026-08-27%20at%2020.51.18.jpeg";

export const NAV_LINKS = [
  { label: "HOME", target: "home" },
  { label: "JOURNEY", target: "chapter-1" },
  { label: "IMPACT", target: "impact" },
  { label: "EXPERIENCE", target: "experience" },
  { label: "INNOVATION", target: "chapter-9" },
  { label: "ABOUT", target: "about" },
  { label: "CONNECT", target: "connect" },
];

export const CHAPTERS = [
  { n: "01", id: "chapter-1", era: "2008 · CIPLA", title: "The Beginning" },
  { n: "02", id: "chapter-2", era: "2009 – 2016 · CIPLA", title: "Learning the Market" },
  { n: "03", id: "chapter-3", era: "2016 – 2017 · IPCA", title: "Becoming a Product Builder" },
  { n: "04", id: "chapter-4", era: "2017 onward · Micro Labs", title: "Building Urology from Scratch" },
  { n: "05", id: "chapter-5", era: "Critical Care Division", title: "Scaling Critical Care" },
  { n: "06", id: "chapter-6", era: "The Launch Engine", title: "Launching Brands" },
  { n: "07", id: "chapter-7", era: "Patient First", title: "Patient-Centric Marketing" },
  { n: "08", id: "chapter-8", era: "Leadership", title: "Leading People & Business" },
  { n: "09", id: "chapter-9", era: "Now", title: "The AI Marketing Era" },
  { n: "10", id: "chapter-10", era: "Beliefs", title: "The Marketing Philosophy" },
  { n: "11", id: "chapter-11", era: "Tomorrow", title: "The Future" },
];

export const UROLOGY_PRODUCTS = [
  { name: "Avoprost", tag: "Silodosin 8 mg Capsule" },
  { name: "Avoprost-D", tag: "Silodosin 8mg + Dutasteride 0.5mg Capsule" },
  { name: "Uronex", tag: "Tamsulosin 0.4mg Tablet" },
  { name: "Uronex D", tag: "Tamsulosin 0.4mg + Dutasteride 0.5mg Capsule" },
  { name: "Avomira", tag: "Mirabegron 25/50 mg Tablets" },
  { name: "Avoprost-M", tag: "BPH with OAB" },
  { name: "Microlift B6", tag: "Potassium Magnesium Citrate + Vitamin B6 Solution 200ml/450ml" },
  { name: "Microfos", tag: "Fosfomycin Trometamol Sachet" },
  { name: "Avomira S", tag: "Mirabegron 25/50 mg + Solifenacin 5mg Tablets" },
  { name: "Microlep", tag: "LHRH Analogue" },
];

export const METRICS = [
  { value: 17, suffix: "+", label: "Product Launches", note: "17 new products in the Urology vertical & 3 products in Critical Care vertical" },
  { value: 10, prefix: "₹", suffix: " Cr", label: "Urology Business Built", note: "Built only from one zone. Now Est. ₹24 Cr in FY 26-27 by launching All India" },
  { value: 104, prefix: "₹", suffix: " Cr", label: "Critical Care Business", note: "Division handled at Micro Labs" },
  { value: 15.4, prefix: "₹", suffix: " Cr", label: "Micropenam Brand", note: "First Critical Care brand to cross ₹15 Cr", decimals: 1 },
  { value: 4.4, prefix: "₹", suffix: " Cr", label: "Zambact-A Brand", note: "Built in the first year of launch", decimals: 1 },
  { value: 7, suffix: "", label: "Sales Personnel", note: "Led with 3 Product Managers" },
  { value: 15, suffix: " yrs", label: "National, Zonal Conference Experience", note: "" },
];

export const TIMELINE = [
  { year: "2008", span: "Jul 2008 – Mar 2009", company: "CIPLA", role: "Medical Representative", note: "Where it all began — the field, doctors, patients, prescriptions." },
  { year: "2009–2016", span: "Apr 2009 – Nov 2016", company: "CIPLA", role: "Pharmaceutical Product Manager", note: "Urology portfolio. Patient-centric strategy with OABPLAN. 12 national USICON conferences." },
  { year: "2016–2017", span: "Nov 2016 – Mar 2017", company: "IPCA", role: "Group Product Manager", note: "Key brands Rapilif & Rapilif D. Helped launch Castramide." },
  { year: "2017–2022", span: "Dec 2017 – Nov 2022", company: "Micro Labs", role: "Marketing Manager", note: "Launched the Urology division from scratch." },
  { year: "2022–2026", span: "Nov 2022 – Mar 2026", company: "Micro Labs", role: "DGM (Marketing & Sales)", note: "DGM (Marketing) from Nov'22 to Jun'24. DGM (Sales & Marketing) from Jul'24 to Mar'26. Additional responsibility of Critical Care along with the Urology division." },
  { year: "2026", span: "Apr'26 onwards", company: "Micro Labs", role: "GM Marketing", note: "Promoted as GM (Marketing) by expanding the division to all-India level. Leading marketing for the Urology division — covering Urology, Gynecology, Nephrology and Uro Oncology." },
];

export const EDUCATION = [
  { title: "Bachelor in Pharmacy", org: "Pune University, Maharashtra", year: "2008", kind: "Degree" },
  { title: "Post Graduation Program in Management for Executives", org: "Great Lakes Executive Learning", year: "2022", kind: "Degree" },
];

export const CERTIFICATIONS = [
  { title: "Certified AI Generalist", org: "AI for Business Professionals Masterclass", year: "2025" },
  { title: "AI for Business Professionals Masterclass", org: "Executive Certification", year: "2025" },
  { title: "Training Program on AI Powered Marketing", org: "MSME Technology Centre, Govt. of India", year: "2026" },
  { title: "How to Use Influence as a Leadership Tool", org: "Dale Carnegie Training", year: "2016" },
  { title: "Sales Leadership Excellence", org: "Dale Carnegie Training", year: "2015" },
];

export const COMPETENCIES = [
  "People Management",
  "Product Positioning",
  "Go-to-Market Strategies",
  "Branding & Positioning",
  "Product Management",
  "Marketing Strategy & Execution",
];
